import { Box, Typography } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { VacancyIncrementor } from './VacancyIncrementor';

export const DistrictVacancies = () => {
  return (
    <Box data-testid={ATSVacanciesModalTestIds.DISTRICT_VACANCIES_PANE}>
      <Typography
        data-testid={ATSVacanciesModalTestIds.DISTRICT_NUMBER_OF_VACANCIES_TEXT}
        sx={{ pb: 1 }}
      >
        Number of vacancies:
      </Typography>
      <VacancyIncrementor type="district" field={'district_ftes_total'} />
    </Box>
  );
};
